'use es6';

import getIn from 'transmute/getIn';
import { DESTINATION_INBOX, ORIGIN_INBOX, AUDIT_AGENT_ID, AUDIT_AGENT_TYPE } from '../constants/keyPaths';
export const getDestinationInbox = getIn(DESTINATION_INBOX);
export const getOriginInbox = getIn(ORIGIN_INBOX);
export const getAuditAgentId = getIn(AUDIT_AGENT_ID);
export const getAuditAgentType = getIn(AUDIT_AGENT_TYPE);